module.exports = __webpack_public_path__ + "img/rum.2b22fc35.webp";